import React from 'react'
import { Field, reduxForm } from 'redux-form'

import { Input } from 'Components/Form/Input/index'
import SubmitButton from 'Components/Form/SubmitButton'
import { validate } from './validate'
import { MessageError } from 'Components/Message/Error'

export let ResetPasswordFormUnstyled = props => {
  return (
    <div className={props.className}>
      <form>
        <h1>Reset Password</h1>
        {renderGeneralErrorMessage()}
        {renderFormBody()}
      </form>
    </div>
  )

  /**
   * Render general error message
   *
   * @returns JSX.Element | null
   */
  function renderGeneralErrorMessage() {
    return props.errorMessage ? (
      <MessageError message={props.errorMessage} />
    ) : null
  }

  function renderFormBody() {
    return props.isCodeAndHashValid
      ? [
          <div key={1} className="form-inputs">
            <Field
              name="password"
              type="password"
              component={Input}
              icon="password"
              id="password"
              placeholder="Password"
            />
          </div>,
          <div key={2} className="form-inputs">
            <Field
              name="passwordConfirm"
              type="password"
              component={Input}
              icon="password"
              id="passwordConfirm"
              placeholder="Confirm Password"
            />
          </div>,
          <SubmitButton
            key={3}
            value="Reset Password"
            onClick={props.handleSubmit}
          />,
        ]
      : null
  }
}

ResetPasswordFormUnstyled = reduxForm({
  // a unique name for the form
  form: 'resetPassword',
  validate: validate,
})(ResetPasswordFormUnstyled)



// WEBPACK FOOTER //
// ./src/Containers/Form/ResetPassword/unstyled.js